module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "boxAtendimento"
    }
  }, [_c('h3', [_vm._v("Atendimento")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtro),
      expression: "filtro"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Pesquisar em Atendimento"
    },
    domProps: {
      "value": (_vm.filtro)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filtro = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "div-pai "
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.acessoBotoes),
      expression: "acessoBotoes"
    }],
    staticClass: "text-right right col-lg-1 botoeslaterais"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "title": "Aguardando Atendimento",
      "disabled": _vm.habilitarBotoes
    },
    on: {
      "click": _vm.aguardandoAtendimento
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loadAguardandoAtendimento),
      expression: "!loadAguardandoAtendimento"
    }],
    staticClass: "fa fa-child",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadAguardandoAtendimento),
      expression: "loadAguardandoAtendimento"
    }],
    staticClass: "fa fa-circle-o-notch fa-spin"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "title": "Iniciar Atendimento",
      "disabled": _vm.habilitarBotoes
    },
    on: {
      "click": _vm.fazerAtendimento
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loadAtendimento),
      expression: "!loadAtendimento"
    }],
    staticClass: "fa fa-user",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadAtendimento),
      expression: "loadAtendimento"
    }],
    staticClass: "fa fa-circle-o-notch fa-spin"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "title": "Iniciar Atendimento Coletivo",
      "disabled": _vm.habilitarBotoes
    },
    on: {
      "click": _vm.fazerAtendimentoColetivo
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loadColetivo),
      expression: "!loadColetivo"
    }],
    staticClass: "fa fa-users",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadColetivo),
      expression: "loadColetivo"
    }],
    staticClass: "fa fa-circle-o-notch fa-spin"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button",
      "title": "Encaminhar Exame Médico",
      "disabled": _vm.habilitarBotoes
    },
    on: {
      "click": _vm.exameMedico
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loadMedico),
      expression: "!loadMedico"
    }],
    staticClass: "fa fa-medkit",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadMedico),
      expression: "loadMedico"
    }],
    staticClass: "fa fa-circle-o-notch fa-spin"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "type": "button",
      "title": "Aguardando Retorno Candidato (Documentação Incompleta, Exame Complementar, etc)",
      "disabled": _vm.habilitarBotoes
    },
    on: {
      "click": _vm.retornoCandidato
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loadRetornoCandidato),
      expression: "!loadRetornoCandidato"
    }],
    staticClass: "fa fa-retweet",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadRetornoCandidato),
      expression: "loadRetornoCandidato"
    }],
    staticClass: "fa fa-circle-o-notch fa-spin"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "title": "Finalizar Atendimento",
      "data-toggle": "modal",
      "data-target": "#modalBaixaEstoque",
      "disabled": _vm.habilitarBotoes
    }
  }, [_c('i', {
    staticClass: "fa fa-check-square-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "divScroll col-lg-11"
  }, [_c('ul', {
    staticClass: "list-group col-lg-12"
  }, _vm._l((_vm.filteredData), function(item) {
    return _c('li', {
      staticClass: "list-group-item text-left"
    }, [_c('span', {
      staticStyle: {
        "width": "275px",
        "display": "inline-block"
      }
    }, [_c('strong', [_vm._v("Hora Marcada:")]), _c('small', [_vm._v(" " + _vm._s(item.DiaHorario.substr(11, 5)) + " ")])]), _vm._v(" "), _c('strong', [_vm._v("Hora Atualização:")]), _vm._v(" "), _c('small', [_vm._v(" " + _vm._s(item.DataAtualizacao != null ? item.DataAtualizacao.substr(11, 5) : '') + " ")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selecionados),
        expression: "selecionados"
      }],
      staticStyle: {
        "float": "right",
        "width": "18px",
        "height": "18px"
      },
      attrs: {
        "type": "checkbox",
        "title": "Selecionar"
      },
      domProps: {
        "value": item,
        "checked": Array.isArray(_vm.selecionados) ? _vm._i(_vm.selecionados, item) > -1 : (_vm.selecionados)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.selecionados,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selecionados = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selecionados = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selecionados = $$c
          }
        }
      }
    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticStyle: {
        "width": "227px",
        "display": "inline-block"
      }
    }, [_c('strong', [_vm._v("Tipo: ")]), _vm._v(" "), (item.TipoAtendimento == 0) ? _c('small', {
      staticClass: "label label-info"
    }, [_vm._v(" Admissão ")]) : _vm._e(), _vm._v(" "), (item.TipoAtendimento == 1) ? _c('small', {
      staticClass: "label label-danger"
    }, [_vm._v(" Rescisão ")]) : _vm._e(), _vm._v(" "), (item.TipoAtendimento == 2) ? _c('small', {
      staticClass: "label label-default"
    }, [_vm._v(" Outros ")]) : _vm._e()]), _vm._v("\n          \n                        "), _c('strong', [_vm._v("Status: ")]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.status(item.Status)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticStyle: {
        "width": "275px",
        "display": "inline-block"
      }
    }, [_c('strong', [_vm._v("Nome: ")]), _vm._v(" " + _vm._s(item.Nome))]), _vm._v(" "), (item.Cpf) ? _c('span', {
      staticStyle: {
        "width": "275px",
        "display": "inline-block"
      }
    }, [_c('strong', [_vm._v("CPF: ")]), _vm._v(" " + _vm._s(item.Cpf))]) : _vm._e(), _vm._v(" "), (item.IdFichaAprovacao) ? _c('span', {
      staticStyle: {
        "width": "275px",
        "display": "inline-block"
      }
    }, [_c('strong', [_vm._v("Ficha Aprovação: ")]), _vm._v(" "), _c('a', {
      attrs: {
        "target": "_blank",
        "href": 'http://fastrhluandre.com.br/FichaAprovacao/Visualizar/' + item.IdFichaAprovacao
      }
    }, [_vm._v(" " + _vm._s(item.IdFichaAprovacao))])]) : _vm._e(), _vm._v(" "), (item.RazaoSocial !== null) ? _c('span', [_c('br'), _vm._v(" "), _c('span', [_c('strong', [_vm._v("Empresa: ")]), _vm._v(_vm._s(item.RazaoSocial))])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v(" Obs.: ")]), _vm._v(" "), _c('small', [_vm._v(_vm._s(item.Observacoes))])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12"
  }, [(this.items.length > 0) ? _c('strong', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(this.items.length) + " pessoa(s) em atendimento. ")]) : _c('strong', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Não há ninguem  em atendimento.")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('Finalizar', {
    attrs: {
      "selecionados": _vm.selecionados
    }
  }), _vm._v(" "), _c('modalAguardarRetorno', {
    attrs: {
      "agendados": _vm.selecionados,
      "idModal": "modalAguardandoEmAtendimento"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79d8c903"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EmAtendimento.vue
// module id = 299
// module chunks = 1